import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import AddItemCard from './AddItemCard';
import R from 'ramda';

const AddItemCardConnected = ({ onClick, text, editable, hide, readOnly }) => {
  if (hide) return <div />;
  if (!editable) return <div style={{ color: 'rgba(0, 0, 0, 0.34)' }}>NA</div>;
  const color = readOnly ? '#9e9e9e' : '#00bcd4';
  return (
    <AddItemCard
      onClick={onClick}
      text={text}
      color={color}
    />
  );
};

AddItemCardConnected.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  editable: PropTypes.bool,
  hide: PropTypes.bool,
  readOnly: PropTypes.bool,
};
const mapStateToProps = ({ user, contracting }) => {
  if (user.getIn(['user', 'email']) && user.getIn(['user', 'email']).indexOf('dl+') > -1) return { readOnly: false };
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const accessForLoc = leftNav.locationId ? R.find(R.propEq('locId', leftNav.locationId), user.get('locAccess')) : {};
  const companyType = user.getIn(['user', 'type']);
  const readOnly = companyType === 'Supplier' && (accessForLoc || {}).contracting && !R.contains('write', (accessForLoc || {}).contracting);
  return { readOnly };
};
export default connect(mapStateToProps)(AddItemCardConnected);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-item-card/add-item-card.jsx